import { TariffZoneApiModel } from './tariff-zone.api-model';
import { StopPointApiModel } from '../journeys/stop-point.api-model';
import type { ICallDetails } from '../../../../models/call-details.model';
import type { IOccupancy } from '../../../../models/occupancy.model';
import { DateTimeHelper } from '../../../../helpers/date-time.helper';

export class CallDetailsApiModel {
  public static mapToBusinessModel(apiModel: CallDetailsApiModel): ICallDetails {
    function parseDateTime(dateTimeString: string | undefined) {
      return dateTimeString ? DateTimeHelper.parse(dateTimeString) : undefined;
    }

    return {
      index: apiModel.index,
      plannedPlatform: apiModel.plannedPlatform,
      estimatedArrivalTime: parseDateTime(apiModel.estimatedArrivalTime),
      isCancelled: apiModel.isCancelled,
      estimatedDepartureTime: parseDateTime(apiModel.estimatedDepartureTime),
      estimatedPlatform: apiModel.estimatedPlatform,
      isOnTripLeg: apiModel.isOnTripLeg,
      isTripLegStart: apiModel.isTripLegStart,
      isTripLegStop: apiModel.isTripLegStop,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      plannedArrivalTime: parseDateTime(apiModel.plannedArrivalTime),
      plannedDepartureTime: parseDateTime(apiModel.plannedDepartureTime),
      tariffZones: apiModel.tariffZones ? apiModel.tariffZones.map(TariffZoneApiModel.mapToBusinessModel) : undefined,
      occupancy: apiModel.occupancy ? apiModel.occupancy : undefined,
      stopPoint: StopPointApiModel.mapToBusinessModel(apiModel.stopPoint),
      realtimeStopPoint: apiModel.realtimeStopPoint ? StopPointApiModel.mapToBusinessModel(apiModel.realtimeStopPoint) : undefined,
      isDepartureCancelled: apiModel.isDepartureCancelled,
      isArrivalCancelled: apiModel.isArrivalCancelled,
    };
  }

  public plannedDepartureTime?: string;
  public plannedArrivalTime?: string;
  public estimatedDepartureTime?: string;
  public estimatedArrivalTime?: string;
  public plannedPlatform!: string;
  public estimatedPlatform?: string;
  public latitude?: number;
  public longitude?: number;
  public index!: string;
  public isCancelled!: boolean;
  public isOnTripLeg?: boolean;
  public isTripLegStart?: boolean;
  public isTripLegStop?: boolean;
  public tariffZones?: TariffZoneApiModel[];
  public occupancy?: IOccupancy;
  public stopPoint!: StopPointApiModel;
  public realtimeStopPoint?: StopPointApiModel;
  public isDepartureCancelled?: boolean;
  public isArrivalCancelled?: boolean;
}
